import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IToken } from 'src/app/interfaces/token/IToken';
import { AuthenticationService, SenhaService } from 'src/app/services';
import { confirmarSenhaValidator } from 'src/app/validators';
@Component({
  selector: 'app-alterar-senha',
  templateUrl: './alterar-senha.component.html',
  styleUrls: ['./alterar-senha.component.scss']
})
export class AlterarSenhaComponent implements OnInit, OnDestroy {
  subscriptions$ = new Subscription();
  formulario: FormGroup;
  token: IToken;

  constructor(
    private authService: AuthenticationService,
    private senhaService: SenhaService,
    private fb: FormBuilder
  ) {}

  sair() {
    this.authService.logoutUsuario();
  }

  prosseguir() {
    this.subscriptions$.add(
      this.senhaService
        .putAlterarSenhaUsuarioLogado(this.formulario.value)
        .subscribe({
          next: () => {
            this.sair();
          }
        })
    );
  }

  ngOnInit(): void {
    this.token = this.authService.obterToken();
    this.formulario = this.fb.group(
      {
        email: [this.token.email, [Validators.required]],
        senhaAntiga: ['', [Validators.required]],
        senhaAtual: [
          '',
          [
            Validators.required,
            Validators.pattern(
              /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&#]).{8,}/
            )
          ]
        ],
        senhaAtualConfirmacao: ['', [Validators.required]]
      },
      {
        validators: [
          confirmarSenhaValidator('senhaAtual', 'senhaAtualConfirmacao')
        ]
      }
    );
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
